export default __webpack_public_path__ + "static/media/bsc_logo.89027194.svg";